import { Layout } from "layouts";
import { useEffect } from "react";

const Careers = () => {
  useEffect(() => {
    window.location.href = "https://hearxgroup.simplify.hr/";
  }, []);

  return (
    <Layout page="careers">
      <div className="grid w-full place-content-center min-h-[30rem]">
        <p>Redirecting to careers page...</p>;
      </div>
    </Layout>
  );
};
export default Careers;
